module.exports = __webpack_public_path__ + "img/lookbook_12_left.e006fead.png";